const MILES_CONVERSION_FACTOR = 0.62171;

export const kmsToMiles = (kmsValue: number) => {
  return kmsValue * MILES_CONVERSION_FACTOR;
};

export const getProductsMiles = <T extends TProductSearch>(products: T): T => {
  let results = products.results;

  products.results = results.map((product) => {
    if (product.mileage) {
      let productMileage =
        typeof product.mileage === 'string'
          ? parseInt(product.mileage, 10)
          : product.mileage;
      product.milageCoUK = kmsToMiles(productMileage);
    }
    return product;
  });

  return products;
};

export const getProductAvailableImages = <T extends TProductSearch>(
  products: T
): T => {
  let results = products.results;

  products.results = results.map((product) => {
    if (product.images) {
      product.listWithImages = product.images.filter(
        ({ src_big, image_big }) => src_big || image_big
      );
    }
    return product;
  });

  return products;
};
